import { MdVerifiedUser } from "@onemind-services-llc/react-icons-ng/md";
import { RiShieldKeyholeLine } from "@onemind-services-llc/react-icons-ng/ri";

export const REVIEW_CONSTANTS = {
  title: "Credit Union Success Stories",
  list: [
    {
      icon: MdVerifiedUser,
      title: "​Audit Compliance​",
      content:
        "A west coast credit union facing an NCUA audient used Onemind’s VCISO services and passed with zero findings, saving over $40,000 in potential penalties and remediation costs.",
    },
    {
      icon: RiShieldKeyholeLine,
      title: "​Ransomware Resilience​",
      content:
        "A credit union quickly detected and restored systems after a phishing-based ransomware attach using Onemind’s SentinelOne EDR, backups – minimizing downtime to 90 minutes and avoiding reputational harm.",
    },
  ],
};

export const NOTE_CONSTANT = {
  title: "Note",
  content:
    "vCISO services offer expert security guidance to help meet regulations like NCUA, PCI, and HIPAA — backed by OneMind’s audit readiness to ensure you're prepared before regulators arrive.",
};
